// 알림 타입
export const ACTIVITY_NOTIFICATION_TYPES = 'ACTIVITY_NOTIFICATION_TYPES';
export const INTEREST_PRODUCT_NOTIFICATION_TYPES = 'INTEREST_PRODUCT_NOTIFICATION_TYPES';
